export default __webpack_public_path__ + "static/media/usercircle.740fab17.svg";